export default __webpack_public_path__ + "static/media/CONCEPCION QUINTANA.00d57a07.jpeg";